import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Analytics from 'APP_ROOT/services/analytics';
import ReportsHeader from './ReportsHeader';
import ReportsSection from './ReportsSection';
import moment from 'moment';

import Selectors from 'APP_ROOT/data/settings/selectors';
import { loadSettings } from 'APP_ROOT/data/settings/actions';
import TagsUtils from '../../components/common/tagsUtils';
import { Selectors as TagsSelectors} from '../../data/tags';
import permissions from '../../data/permissions';

export class Reports extends React.PureComponent {

    constructor (props) {

        super(props);

        this.state = {
            // FIXME - selectedDateRange default start is also defined in ReportsHeader.js
            selectedDateRange: [ moment().subtract(2, 'days').toDate(), moment().toDate() ],
            groupBy: 'vehicle',
            showDrivingParking: 'both',
            filterByTags: [],
            filteredResources: {},
        }
    }

    componentDidMount() {

        Analytics.pageView();

        if (!this.props.settingsLoaded) {
            this.props.loadSettings();
        }
    }

    setDateRange = (range) => {

        this.setState({selectedDateRange: range});

    }

    getDateRange() {

        return this.state.selectedDateRange;
    }

    handleGroupByChange = groupBy => {
        this.setState({ groupBy });
    }

    handleShowDrivingParkingChange = showDrivingParking => {
        this.setState({ showDrivingParking });
    }

    handleFilterByTagsChange = filterByTags => {
        const filteredResources = this.getFilteredResources(filterByTags);
        this.setState({ filterByTags, filteredResources });
    }

    getFilteredResources = (filterByTags) => {
        const filteredResources = {};

        if(!this.props.tags) {
            return filteredResources;
        }

        const selectedTags = this.props.tags.filter(tag => filterByTags.includes(tag.tagId));

        if(selectedTags.length === 0) {
            return filteredResources;
        }

        filteredResources.ravens = TagsUtils.getUuidOfRavensInTheSelectedTags(selectedTags);
        // Other resources will be added here (geofences, assets, etc)

        return filteredResources;
    }

    render() {

        if(!this.props.user) {
            return null;
        }

        const { unitOfMeasure } = this.props;

        const {
            groupBy,
            showDrivingParking,
            filterByTags,
            filteredResources
        } = this.state;
        return (
            <div className="container fleet-reports-page">
                <ReportsHeader
                    {...this.props}
                    selectDateRange={this.setDateRange}
                    handleGroupByChange={this.handleGroupByChange}
                    handleShowDrivingParkingChange={this.handleShowDrivingParkingChange}
                    handleFilterByTagsChange={this.handleFilterByTagsChange}
                    groupBy={groupBy}
                    showDrivingParking={showDrivingParking}
                    filterByTags={filterByTags}
                />
                <ReportsSection
                    {...this.props}
                    groupBy={groupBy}
                    showDrivingParking={showDrivingParking}
                    limitTo={filteredResources}
                    selectedDateRange={this.getDateRange()}
                    unitOfMeasure={unitOfMeasure}
                />
            </div>
        );
    }
}

Reports.propTypes = {
    settingsLoaded: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    loadSettings: PropTypes.func.isRequired,
    unitOfMeasure: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    settingsError: PropTypes.object,
    tags: PropTypes.array,
    tagsLoaded: PropTypes.bool,
    tagsError: PropTypes.object,
    tagsLoading: PropTypes.bool,
    canAccessAssetsReport: PropTypes.bool,
    features: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
    return {
        settingsLoaded: Selectors.settingsLoaded(state),
        unitOfMeasure: Selectors.unitOfMeasure(state),
        settingsError: Selectors.error(state),
        tags: TagsSelectors.tags(state),
        tagsLoaded: TagsSelectors.loaded(state),
        tagsError: TagsSelectors.error(state),
        tagsLoading: TagsSelectors.loading(state),
        canAccessAssetsReport: permissions.selectors.can(state, 'assets', 'read') && ownProps.features?.has_beacons, // user needs read access to assets and account needs to have beacons to show assets report
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadSettings: () => dispatch(loadSettings(ownProps.user.stage)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reports);
